<template>
  <div
    class="ag-state-banner"
    :class="{'ag-state-banner--inactive': inactiveStatus}"
  >
    <div class="ag-state-banner__body">
      <ag-icon
        v-if="inactiveStatus"
        modifier="dot"
        name="dot"
      />
      <ag-icon
        v-if="inactiveStatus"
        modifier="dot"
        name="dot"
      />
      {{ getBannerText }}
      <ag-icon
        v-if="inactiveStatus"
        modifier="dot"
        name="dot"
      />
      <ag-icon
        v-if="inactiveStatus"
        modifier="dot"
        name="dot"
      />
      <ag-icon
        v-if="!inactiveStatus"
        modifier="check-circle"
        name="check-circle"
      />
    </div>
  </div>
</template>

<script>
import AgIcon from '@/components/shared/AgIcon.vue';

export default {
  name: 'ag-state-banner',
  components: {
    AgIcon,
  },
  props: {
    inactiveStatus: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    getBannerText() {
      if (this.inactiveStatus) {
        return 'Jetzt buchbar';
      }
      return 'Abo läuft';
    },
  },
};
</script>

<style lang="scss">

.ag-state-banner {
  font-size: rem(14px);
  padding: rem(10px);
  text-transform: uppercase;
  font-weight: 600;
  text-align: center;
  width: 100%;
  background-color: $bg-dark-color;

  &--inactive {
    color: #754E1D;
    background-color: rgba(201,157,102,0.3);
  }

  &--standalone {
    margin-top: rem(10px);

    @include mq($mq-large) {
      width: rem(200px);
      margin-top: 0;
    }
  }

  &__body {

  }
}
</style>
